"use strict";

exports.__esModule = true;
exports.default = void 0;

var _renderPropsVersion = _interopRequireDefault(require("./render-props-version"));

exports.RenderPropSticky = _renderPropsVersion.default;

var _basicVersion = _interopRequireDefault(require("./basic-version"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _basicVersion.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-sticky-el/lib/index.js
// module id = 912
// module chunks = 0